"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ImageWrapper;
var _react = _interopRequireDefault(require("react"));
var _constants = require("../../utils/constants");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ImageWrapper(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("picture", {
    className: props.className,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("source", {
      "data-testid": "desktop-src",
      media: "(min-width: ".concat(_constants.breakpoints.desktop, "px)"),
      srcSet: props.desktop
    }), props.tablet && /*#__PURE__*/(0, _jsxRuntime.jsx)("source", {
      "data-testid": "tablet-src",
      media: "(min-width: ".concat(_constants.breakpoints.tablet, "px)"),
      srcSet: props.tablet
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
      src: props.mobile,
      alt: props.altText || ''
    })]
  });
}